<template>
  <div class="p-grid">
    <div class="p-col-12">
      <br />
      

      <h4>List of Linked Accounts</h4>

      <Toolbar class="p-mb-4">
        <template slot="left">
          <Button
            label="New Account"
            icon="pi pi-plus"
            class="p-button-success p-mr-2"
            @click="openNew"
          />
        </template>

        <template slot="right">
          <span class="p-input-icon-left">
            <i class="pi pi-search" />
            <InputText
              v-model="filters['global']"
              placeholder="Global Search"
              style="margin-right: 0.5em"
              @input="updateSearch"
            />
          </span>
        </template>
      </Toolbar>
    
      <!-- Account Form -->
      <AccountForm
        :accountDialog="accountDialog"
        :reload="realodAccountDialog"
        :refresh="refreshAccountDialog"
        :accountToEdit="account"
        :customer="customer"
        :disabledArr="disabledArr"
        @close="accountDialog = false"
        @saved="savedAccount"
      />

    </div>
  </div>
</template>

<script>
import CustomerService from "@/service/CustomerService";

import AccountForm from '../../universalComponents/customer/AccountForm'

export default {
  components: {
    AccountForm
  },
  props: ["customer"],
  data: () => ({
    customerService: new CustomerService(),
    filters: {},
    accountDialog: false,
    account: {},
    disabledArr: [],
    requesting: false,
    realodAccountDialog: 0,
    refreshAccountDialog: 0
  }),
  computed: {
    loading() {
      if (this.accounts && this.accounts[0]) {
        return false
      } else {
        if (this.requesting) {
          return true
        } else {
          return false
        }
      }
    }
  },
  created() {
    if (this.$route.query.search !== '') {
      this.updateSearch('')
    }
    this.getCustomerGroups(this.customer.customerId)
  },
  watch: {
    customer(val) {
      if (val && val.customerId) {
        if (this.accountDialog) {
          this.account.customerId = val.customerId
          this.account.mbpBranch = val.mbpBranch
          this.refreshAccountDialog++
        }
      }
    }
  },
  methods: {
    getCustomerGroups(customerId) {
      this.requesting = true
      this.customerService
        .getCustomerGroups(customerId)
        .then(data => {
          this.requesting = false
        })
        .catch(err => {
          this.requesting = false
          
          
                
          // this.$store.dispatch('addErrorMessage', {
          //   severity: 'error',
          //   content: 'Some data was not loaded from "quotationactivities/{quoteVerId}"'
          // })
        })
    },
    savedAccount({ account }) {
      
      this.accountDialog = false
      this.getCustomerGroups(this.customer.customerId)
    },
    openNew() {
      this.disabledArr = [
        'customer'
      ]

      this.account.customerId = this.customer.customerId
      this.account.mbpBranch = this.customer.mbpBranch
      this.account.mainBranch = false
      this.account.active = true
      
      this.accountDialog = true
      this.refreshAccountDialog++
      this.realodAccountDialog++
    },
    updateSearch(e) {
      this.$router.push({ query: { search: e } });
    }
  }
}
</script>

<style>

</style>